import Vue from 'vue';
export const runDemographicsTest = (state, { status, error }) => {
  if (state.applicant.demographic) {
    Vue.set(state.applicant.demographic, 'runTestStatus', status);
    Vue.set(state.applicant.demographic, 'runTestError', error);
  }
};
